import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import "@fontsource/plus-jakarta-sans/400.css"; // Peso Regular
import "@fontsource/plus-jakarta-sans/500.css"; // Peso Medium
import "@fontsource/plus-jakarta-sans/700.css"; // Peso Bold
import "@fontsource/plus-jakarta-sans/800.css"; // Peso ExtraBold
import { QueryProvider } from './providers/query-provider.tsx';

createRoot(document.getElementById('root')!).render(
  <QueryProvider>
    <StrictMode>
      <App />
    </StrictMode>
  </QueryProvider>
)
